import React from 'react';
import './library-skeleton.css';

interface LibrarySkeletonLoaderProps {
    count?: number;
    variant?: 'process' | 'folder' | 'insight';
}

const LibrarySkeletonLoader: React.FC<LibrarySkeletonLoaderProps> = ({ 
    count = 4, 
    variant = 'process' 
}) => {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className={`lib-skeleton lib-skeleton-${variant}`}>
                    {variant === 'folder' && (
                        <div className="lib-skeleton-folder-header">
                            <div className="lib-skeleton-folder-icon"></div>
                            <div className="lib-skeleton-folder-title"></div>
                            <div className="lib-skeleton-badge"></div>
                        </div>
                    )}
                    {variant === 'process' && (
                        <>
                            <div className="lib-skeleton-header">
                                <div className="lib-skeleton-title"></div>
                                <div className="lib-skeleton-menu"></div>
                            </div>
                            <div className="lib-skeleton-desc"></div>
                            <div className="lib-skeleton-desc" style={{ width: '70%' }}></div>
                            <div className="lib-skeleton-meta">
                                <div className="lib-skeleton-tag"></div>
                                <div className="lib-skeleton-text"></div>
                            </div>
                        </>
                    )}
                    {variant === 'insight' && (
                        <>
                            <div className="lib-skeleton-title"></div>
                            <div className="lib-skeleton-desc"></div>
                            <div className="lib-skeleton-desc" style={{ width: '60%' }}></div>
                        </>
                    )}
                </div>
            ))}
        </>
    );
};

export default LibrarySkeletonLoader;
